<template>
  <v-flex xs12>
    <v-data-table
      :options.sync="options"
      :server-items-length="totalGeotags"
      :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, 200, 300, -1] }"
      :headers="headersGeotags"
      :items="items"
      :fixed-header="true"
      :single-expand="true"
      v-resize="debounceResize"
      :height="tableHeight"
      ref="reportTable"
    >

      <template v-slot:body.prepend>
        <tr class="filter-row">
          <td>
            <v-text-field
              :value="geotagFilters.id"
              @change="v=>geotagFilters.id=v"
              type="number"
              label="id"
              clearable
              @keyup.enter="getReportApiData"
              @click:clear="onClearFilter('id')"
            />
          </td>
          <td>
            <v-text-field
              :value="geotagFilters.name"
              @change="v=>geotagFilters.name=v"
              type="text"
              label="geotag name"
              clearable
              @keyup.enter="getReportApiData"
              @click:clear="onClearFilter('name')"
            />
          </td>
          <td>
            <v-text-field
              :value="geotagFilters.country"
              @change="v=>geotagFilters.country=v"
              type="text"
              label="country"
              clearable
              @keyup.enter="getReportApiData"
              @click:clear="onClearFilter('country')"
            />
          </td>
          <td>
            <v-text-field
              :value="geotagFilters.state"
              @change="v=>geotagFilters.state=v"
              type="text"
              label="state"
              clearable
              @keyup.enter="getReportApiData"
              @click:clear="onClearFilter('state')"
            />
          </td>
          <td>
            <DataList
              :item-model.sync="geotagFilters.customers"
              :type-object="$constants.DATA_LISTS.CUSTOMER_LIST"
              label="customers"
              @change="getReportApiData"
              multiple
              clearable
              dense
              chips
              small-chips
              deletable-chips
              with-option-none
              with-option-any
              with-option-select-all
            />
          </td>
          <td>
          </td>
          <td>
            <v-autocomplete
              v-model="geotagFilters.status"
              :items="['off', 'prev', 'prev only', 'live']"
              label="status"
              dense
              chips
              small-chips
              deletable-chips
              @click:clear="onClearFilter('status')"
              @change="getReportApiData"
              :menu-props="{ closeOnContentClick: true }"
            />
          </td>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
          <td/>
        </tr>
      </template>

      <template v-slot:top>
        <v-toolbar
          flat
        >

          <v-dialog
            v-model="reportdialog.show"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-2"
                color="primary"
                v-bind="attrs"
                v-on="on"
                :disabled="reportdialog.disabled"
                fab
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-tune-vertical
                      </v-icon>
                    </slot>
                  </template>
                  report options
                </v-tooltip>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Report options</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row
                    align="center"
                    justify="space-between"
                  >POI status:
                    <v-switch
                      v-model="reportdialog.isWithEnabledPois"
                      label="Enabled"
                    />
                    <v-switch
                      v-model="reportdialog.isWithDisabledPois"
                      label="Disabled"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >
                    Priority:
                    <v-switch
                      v-model="reportdialog.isWithPriority1"
                      label="1"
                    />
                    <v-switch
                      v-model="reportdialog.isWithPriority2"
                      label="2"
                    />
                    <v-switch
                      v-model="reportdialog.isWithPriority3"
                      label="3"
                    />
                    <v-switch
                      v-model="reportdialog.isWithPriority4"
                      label="4"
                    />
                    <v-switch
                      v-model="reportdialog.isWithPriorityNotSet"
                      label="Not Set"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >AI status:
                    <v-switch
                      v-model="reportdialog.isWithAI"
                      label="With AI"
                    />
                    <v-switch
                      v-model="reportdialog.isWithoutAI"
                      label="Without AI"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >Images:
                    <v-switch
                      v-model="reportdialog.isWithImages"
                      label="With images"
                    />
                    <v-switch
                      v-model="reportdialog.isWithoutImages"
                      label="Without images"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >Videos:
                    <v-switch
                      v-model="reportdialog.isWithVideos"
                      label="With videos"
                    />
                    <v-switch
                      v-model="reportdialog.isWithoutVideos"
                      label="Without videos"
                    />
                  </v-row>
                  <v-row
                    align="center"
                    justify="space-between"
                  >
                    Percentages:
                    <v-switch
                      v-model="reportdialog.showPercentages"
                      label="Show"
                    />
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="reportdialog.show = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  @click="getReportApiData"
                  color="blue darken-1"
                  text
                >
                  Apply
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
            @click="exportGeotags"
            class="mx-2"
            color="primary"
            dark
            fab
            small
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <slot>
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    dark
                  >
                    mdi-export
                  </v-icon>
                </slot>
              </template>
              export filtered geotags
            </v-tooltip>
          </v-btn>

          <v-dialog
            v-model="metricsChartData.show"
            width="initial"
          >
            <template v-slot:activator="{}">
              <v-btn
                class="mx-2"
                color="primary"
                dark
                fab
                small
                @click="getMetricsChartData"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-chart-bar
                      </v-icon>
                    </slot>
                  </template>
                  Metrics Chart Data
                </v-tooltip>
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                Metrics Chart Data
              </v-card-title>

              <v-card-text>
                <table style="border-collapse: collapse;">
                  <tr>
                    <th v-for="(value, index) in metricsChartData.data" :key="index"
                        class="px-2" style="border: 1px solid #ccc"
                    >
                      {{ index }}
                    </th>
                  </tr>
                  <tr>
                    <td v-for="(value, index) in metricsChartData.data" :key="index"
                        class="px-2" style="border: 1px solid #ccc"
                    >
                      {{ value }}
                    </td>
                  </tr>
                </table>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="metricsChartData.show = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-dialog
          v-model="paramdialog.show"
          max-width="75%"
        >
          <v-card>
            <v-card-title>
              <v-btn
                v-if="!hasSomeAbilities($constants.ABILITY.INTERN)"
                @click="exportPoi"
                class="mx-2"
                color="primary"
                dark
                fab
                small
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <slot>
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        dark
                      >
                        mdi-export
                      </v-icon>
                    </slot>
                  </template>
                  export filtered POIs
                </v-tooltip>
              </v-btn>
              {{ paramdialog.title }}
              <v-spacer></v-spacer>
              <v-text-field
                :value="commonSearch"
                @change="v=>commonSearch=v"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                clearable
                @keyup.enter="onEnterSearch"
                @click:clear="onClearSearch"
              ></v-text-field>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-data-table
                  :options.sync="poisOptions"
                  :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                  :server-items-length="paramdialog.totalPois"
                  :items="paramdialog.items"
                  :headers="paramdialog.headers"
                  :fixed-header="true"
                >
                  <template v-slot:item.name="{ item }">
                    <span>{{ item.name }}</span>
                    <v-btn
                      :to="`poi/${item.id}`" target="_blank"
                      icon
                      small
                    >
                      <v-icon color="orange" dense>
                        mdi-pen
                      </v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:item.tips="{ item }">
                    <div v-html="item.tips"></div>
                  </template>

                  <template v-slot:item.enabled="{ item }">
                    <v-switch
                      v-model="item.enabled"
                      readonly
                    />
                  </template>

                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="paramdialog.show = false"
              >
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>

      <template v-slot:item.name="{ item }">
        <span>{{ item.name }}</span>
        <v-btn
          :to="`geotag/${item.id}`" target="_blank"
          icon
          small
        >
          <v-icon color="orange" dense>
            mdi-pen
          </v-icon>
        </v-btn>
      </template>

      <template v-slot:item.customers="{ item }">
        <v-chip
          v-for="tag in item.customers"
          :key="tag.name"
          class="ma-0"
          dark
          small
        >
          {{ tag.name }}
        </v-chip>
      </template>

      <template v-slot:item.sequence="{ item }">
        <v-chip
          v-for="tag in item.sequenceGeotags"
          :key="tag.name"
          class="ma-0"
          dark
          small
        >
          {{ tag.name }}
        </v-chip>
      </template>

      <template v-slot:item.status="{ item }">
        <TripleButton
          :status="item.status"
          :disabled="true"
        />

      </template>

      <template v-slot:item.pois_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'total')"
                >{{ item.pois_count }}</span>
          </template>
          total pois
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_ambassador_video_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="with-pointer font-weight-bold"
              @click="callParamDialog(item, 'with_ambassador_videos')"
            >
              {{ showValueOrPercentages(item.pois_with_ambassador_video_count, item.pois_count) }}
            </span>
          </template>
          with ambassador videos
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="with-pointer font-weight-bold"
              @click="callParamDialog(item, 'without_ambassador_videos')"
            >
              ( {{
                showValueOrPercentages(item.pois_with_ambassador_video_count, item.pois_count, true)
              }} )
            </span>
          </template>
          without ambassador videos
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_amb_in_work_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_amb_in_work_count')"
                >
                  {{ showValueOrPercentages(item.pois_with_amb_in_work_count, item.pois_count) }}
                </span>
          </template>
          with videos in Portal
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_common_video_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_videos')"
                >
                  {{ showValueOrPercentages(item.pois_with_common_video_count, item.pois_count) }}
                </span>
          </template>
          with videos
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="with-pointer font-weight-bold"
              @click="callParamDialog(item, 'without_videos')"
            >
              ( {{
                showValueOrPercentages(item.pois_with_common_video_count, item.pois_count, true)
              }} )
            </span>
          </template>
          without videos
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_images_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_images')"
                >
                  {{ showValueOrPercentages(item.pois_with_images_count, item.pois_count) }}
                </span>
          </template>
          with images
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="with-pointer font-weight-bold"
                    @click="callParamDialog(item, 'without_images')"
                  >( {{
                      showValueOrPercentages(item.pois_with_images_count, item.pois_count, true)
                    }} )
              </span>
          </template>
          without images
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_slide_video_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_slides')"
                >
                  {{ showValueOrPercentages(item.pois_with_slide_video_count, item.pois_count) }}
                </span>
          </template>
          with slides
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              v-on="on"
              class="with-pointer font-weight-bold"
              @click="callParamDialog(item, 'without_slides')"
            >
              ( {{
                showValueOrPercentages(item.pois_with_slide_video_count, item.pois_count, true)
              }} )
            </span>
          </template>
          without slides
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_tbl_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_tips')"
                >
                  {{ showValueOrPercentages(item.pois_with_tbl_count, item.pois_count) }}
                </span>
          </template>
          with tips
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="with-pointer font-weight-bold"
                    @click="callParamDialog(item, 'without_tips')"
                  >( {{
                      showValueOrPercentages(item.pois_with_tbl_count, item.pois_count, true)
                    }} )
              </span>
          </template>
          without tips
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_ai_done_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_ai_done')"
                >
                  {{ showValueOrPercentages(item.pois_with_ai_done_count, item.pois_count) }}
                </span>
          </template>
          with AI done
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="with-pointer font-weight-bold"
                    @click="callParamDialog(item, 'without_ai_done')"
                  >( {{
                      showValueOrPercentages(item.pois_with_ai_done_count, item.pois_count, true)
                    }} )
              </span>
          </template>
          without AI done
        </v-tooltip>
      </template>

      <template v-slot:item.pois_with_prod_count="{ item }">
            <span class="with-pointer font-weight-bold">
              {{ item.pois_with_prod_count || 0 }}
            </span>
        (<span class="with-pointer font-weight-bold">{{
          item.pois_with_prod_count
            ? item.pois_count - item.pois_with_prod_count
            : 0
        }}</span>)
      </template>

      <template v-slot:item.pois_with_reviews_count="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  class="with-pointer font-weight-bold"
                  @click="callParamDialog(item, 'with_reviews')"
                >
                  {{ showValueOrPercentages(item.pois_with_reviews_count, item.pois_count) }}
                </span>
          </template>
          with reviews
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="with-pointer font-weight-bold"
                    @click="callParamDialog(item, 'without_reviews')"
                  >( {{
                      showValueOrPercentages(item.pois_with_reviews_count, item.pois_count, true)
                    }} )
              </span>
          </template>
          without reviews
        </v-tooltip>
      </template>

    </v-data-table>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import debounce from 'lodash.debounce';
import TripleButton from '../components/TripleButton.vue';
import DataList from '../components/DataLists/DataList.vue';

export default {
  name: 'Report',
  components: {
    DataList,
    TripleButton,
  },
  data: () => ({
    options: {
      itemsPerPage: 50,
      sortBy: ['id'],
      sortDesc: [false],
      mustSort: true,
      multiSort: false,
    },
    poisOptions: {
      itemsPerPage: 10,
      sortBy: ['id'],
      sortDesc: [false],
      mustSort: true,
      multiSort: false,
    },
    isPoisTableiInit: false,
    totalGeotags: 0,
    items: [],
    commonSearch: null,
    geotagFilteredParams: {
      geotagId: null,
      filter: null,
      geotagName: null,
    },
    geotagFilters: {
      id: null,
      name: '',
      customers: null,
      status: null,
    },
    poiFilters: {
      name: '',
    },
    paramdialog: {
      totalPois: 0,
      show: false,
      title: null,
      geotagId: null,
      items: [],
      headers: [
        { text: 'Id', value: 'id', width: '80px' },
        { text: 'Name', value: 'name', width: '300px' },
        { text: 'Priority', value: 'priority', width: '80px' },
        { text: 'Any content', value: 'videos_count', width: '80px' },
        { text: 'Videos', value: 'commonvideodata_count', width: '80px' },
        { text: 'Images', value: 'poi_images_count', width: '80px' },
        { text: 'Ambassador videos', value: 'ambassadorvideodata_count', width: '80px' },
        { text: 'Slides', value: 'slidevideodata_count', width: '80px' },
        { text: 'Products', value: 'products_count', width: '80px' },
        { text: 'Tips', value: 'tips', width: '200px' },
        { text: 'Reviews', value: 'reviews_count', width: '80px' },
        { text: 'Enabled', value: 'enabled', width: '80px' },
        { text: 'Tripexpert ID', value: 'tripexpert_id', width: '100px' },
      ],
      filter: null,
      isChanged: false,
      filters: {
        total: 'total',
        with_any_content: 'with any content',
        without_any_content: 'without any content',
        with_videos: 'with videos',
        without_videos: 'without videos',
        with_ambassador_videos: 'with ambassador videos',
        without_ambassador_videos: 'without ambassador videos',
        with_slides: 'with slides',
        without_slides: 'without slides',
        with_tips: 'with tips',
        without_tips: 'without tips',
        with_products: 'with products',
        without_products: 'without products',
        with_reviews: 'with reviews',
        without_reviews: 'without reviews',
        mvp_priority: 'mvp priority',
        mvp_priority_enabled: 'mvp priority enabled',
        full_priority: 'full priority',
        full_priority_enabled: 'full priority enabled',
        mvp_video_mvp_enabled: 'enabled 1-3 priority with 0-4 video order',
        mvp_video_full: 'all 1-3 priority with 0-8 video order',
        without_ai_done: 'without AI done',
        with_ai_done: 'with AI done',
        with_images: 'with images',
        without_images: 'without images',
      },
    },
    reportdialog: {
      show: false,
      disabled: false,
      isWithEnabledPois: true,
      isWithDisabledPois: true,
      isWithPriority1: true,
      isWithPriority2: true,
      isWithPriority3: true,
      isWithPriority4: true,
      isWithPriorityNotSet: true,
      showPercentages: false,
      isWithAI: true,
      isWithoutAI: true,
      isWithImages: true,
      isWithoutImages: true,
      isWithVideos: true,
      isWithoutVideos: true,
    },
    metricsChartData: {
      show: false,
      data: [],
    },
    tableHeight: null,
    headersGeotags: [
      {
        text: 'Id',
        value: 'id',
        width: '80px',
      },
      {
        text: 'Geotag',
        value: 'name',
        width: '150px',
      },
      {
        text: 'Country',
        value: 'country',
        width: '150px',
        sortable: false,
      },
      {
        text: 'State',
        value: 'state',
        width: '150px',
        sortable: false,
      },
      {
        text: 'Customers', value: 'customers', width: '300px', sortable: false,
      },
      {
        text: 'Sequence', value: 'sequence', width: '300px', sortable: false,
      },
      {
        text: 'Status', value: 'status', width: '110px',
      },
      { text: 'Total', value: 'pois_count', width: '110px' },
      { text: 'SM image', value: 'deep_link_images_count', width: '110px' },
      { text: 'Videos', value: 'pois_with_common_video_count', width: '110px' },
      { text: 'Images', value: 'pois_with_images_count', width: '110px' },
      { text: 'Ambassador videos', value: 'pois_with_ambassador_video_count', width: '110px' },
      { text: 'Portal', value: 'pois_with_amb_in_work_count', width: '110px' },
      { text: 'Slides', value: 'pois_with_slide_video_count', width: '110px' },
      { text: 'AI', value: 'pois_with_ai_done_count', width: '110px' },
      { text: 'TBL', value: 'pois_with_tbl_count', width: '110px' },
      { text: 'Reviews', value: 'pois_with_reviews_count', width: '110px' },
    ],
  }),

  created() {
  },

  mounted() {
    this.onResize();
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    onClearFilter(filterName) {
      switch (filterName) {
        case 'id':
          this.geotagFilters.id = null;
          break;
        case 'name':
          this.geotagFilters.name = null;
          break;
        case 'customers':
          this.geotagFilters.customers = null;
          break;
        case 'sequence':
          this.geotagFilters.sequence = null;
          break;
        case 'country':
          this.geotagFilters.country = null;
          break;
        case 'state':
          this.geotagFilters.state = null;
          break;
        case 'status':
          this.geotagFilters.status = null;
          break;
        default:
      }
      this.getReportApiData();
    },

    onEnterSearch() {
      this.getFilteredPois();
    },

    onClearSearch() {
      this.commonSearch = null;
      this.getFilteredPois();
    },

    onResize() {
      this.tableHeight = window.innerHeight - 240;
    },

    getReportApiData() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.$requestHelpers
        .post('api/admin/report/reportPage',
          {
            bit_mask: this.bitMask,
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
            filters: this.geotagFilters,
          })
        .then((response) => {
          this.items = response.data.data;
          this.totalGeotags = response.data.total;
          this.options.page = response.data.current_page > response.data.last_page
            ? response.data.last_page
            : response.data.current_page;
        }).finally(() => {
          this.reportdialog.show = false;
        });
    },

    callParamDialog(item, filter) {
      Object.assign(this.geotagFilteredParams, {
        geotagId: item.id,
        filter,
        geotagName: item.name,
      });
      this.paramdialog.items = [];
      this.paramdialog.show = true;
    },

    getFilteredPois() {
      this.isPoisTableiInit = true;
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.poisOptions;

      this.$requestHelpers
        .post('api/admin/report/filteredPois',
          {
            sortBy,
            sortDesc,
            page,
            itemsPerPage,
            geotag_id: this.geotagFilteredParams.geotagId,
            filter: this.geotagFilteredParams.filter,
            filters: { name: this.commonSearch },
            bit_mask: this.bitMask,
          })
        .then((response) => {
          this.paramdialog.title = `${this.geotagFilteredParams.geotagName}: ${this.paramdialog.filters[this.geotagFilteredParams.filter]}`;
          this.paramdialog.filter = this.geotagFilteredParams.filter;
          this.paramdialog.geotagId = this.geotagFilteredParams.geotagId;
          this.paramdialog.totalPois = response.data.total;
          this.paramdialog.items = response.data.data;
          this.poisOptions.page = response.data.current_page > response.data.last_page
            ? response.data.last_page
            : response.data.current_page;
        });
    },

    exportPoi() {
      const {
        sortBy, sortDesc,
      } = this.poisOptions;
      this.$requestHelpers
        .post('api/admin/report/exportReportPois',
          {
            sortBy,
            sortDesc,
            geotag_name: this.geotagFilteredParams.geotagName,
            geotag_id: this.paramdialog.geotagId,
            filter: this.paramdialog.filter,
            bit_mask: this.bitMask,
            filters: { name: this.commonSearch },
          },
          {
            responseType: 'blob',
          })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename="(.*)"/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },

    exportGeotags() {
      const {
        sortBy, sortDesc,
      } = this.options;
      this.$requestHelpers
        .post('api/admin/report/exportReportGeotags',
          {
            sortBy,
            sortDesc,
            bit_mask: this.bitMask,
            filters: this.geotagFilters,
          },
          {
            responseType: 'blob',
          })
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          const headerval = response.headers['content-disposition'];
          const filename = headerval.match(/filename="(.*)"/);

          fileLink.href = fileURL;
          fileLink.setAttribute('download', filename[1]);
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },

    getMetricsChartData() {
      this.$requestHelpers
        .get('api/admin/report/getReportMetricsChartData')
        .then((response) => {
          this.metricsChartData.data = response.data;
          this.metricsChartData.show = true;
        });
    },

    showValueOrPercentages(value, total, revers = false) {
      let result = value;

      if (total === 0) {
        return '_';
      }

      if (revers) {
        result = total - result;
      }

      if (this.reportdialog.showPercentages) {
        result = `${((result * 100) / total).toFixed(2)}%`;
      }

      return result;
    },
  },

  computed: {
    bitMask() {
      let val = 0;
      val += this.reportdialog.isWithEnabledPois ? 1 : 0;
      val += this.reportdialog.isWithDisabledPois ? 2 : 0;
      val += this.reportdialog.isWithPriority1 ? 4 : 0;
      val += this.reportdialog.isWithPriority2 ? 8 : 0;
      val += this.reportdialog.isWithPriority3 ? 16 : 0;
      val += this.reportdialog.isWithPriority4 ? 32 : 0;
      val += this.reportdialog.isWithPriorityNotSet ? 64 : 0;
      val += this.reportdialog.isWithAI ? 128 : 0;
      val += this.reportdialog.isWithoutAI ? 256 : 0;
      val += this.reportdialog.isWithImages ? 512 : 0;
      val += this.reportdialog.isWithoutImages ? 1024 : 0;
      val += this.reportdialog.isWithVideos ? 2048 : 0;
      val += this.reportdialog.isWithoutVideos ? 4096 : 0;
      return val;
    },
    debounceResize() {
      return debounce(this.onResize, 100);
    },
  },

  watch: {
    options: {
      handler() {
        this.getReportApiData();
      },
      deep: true,
    },
    poisOptions: {
      handler() {
        this.getFilteredPois();
      },
      deep: true,
    },
    // eslint-disable-next-line func-names
    'paramdialog.show': function (val) {
      if (val === true && this.isPoisTableiInit) {
        this.getFilteredPois();
      }
    },
  },

};
</script>

<style scoped>
.with-pointer {
  cursor: pointer;
}

.custom-blue .v-input--selection-controls__input div {
  color: #42a5f5;
}
</style>
